<template>
    
    <div class="thresholds">
        <div class="bg-black p-2 rounded" style="">

            <!-- Header -->
            <div v-if="false" class="row">
                <div class="col-md-4"></div>
                <div class="col-md-4">
                    <input type="text" class="btn bg-black text-white fw-light fs-2 w-100 mt-1" :class="{'fa-fade': false }" style="letter-spacing: 5px; cursor: default; opacity: 1;" value="Thresholds" disabled>

                </div>

            </div>
            <!-- Modifier -->
            <div class="row">
                
                <div class="col-md-12 mb-2">
                    <div class="input-group flex-nowrap">
                        <input type="text" class="btn bg-black text-white fw-light fs-2 mt-1" :class="{'fa-fade': false }" style="letter-spacing: 5px; cursor: default; opacity: 1;" value="Thresholds" disabled>
                        <div style="width: 20%;"></div>
                        <button class="btn btn-deg-alchemy bg-gradient rounded fs-4" style="width: 10%;" @click="getDevices()">
                            <i class="fa-solid fa-refresh" :class="{'fa-spin': gettingDevices}"></i>
                        </button>
                        <input class="btn btn-deg-alchemy rounded" type="text" style="width: 30%; cursor: text;" placeholder="Search by name, alias, IP or OS." v-model="keyword">
                        <button class="btn btn-deg-alchemy bg-gradient rounded fs-5" style="width: 15%; pointer-events: none;">
                            {{filtered.length}}
                        </button>
                        <div style="width: 10%;"></div>
                        <button class="btn btn-success rounded fs-4" style="width: 5%;" @click="SaveChanges('detailed');" :disabled="saving">
                            <i class="fa-solid fa-save" :class="{'fa-fade': saving}"></i>
                        </button>
                    </div>
                </div>
                <div class="col-md-12">
                    <div class="p-2 border-bottom border-0 border-info" style="height: 510px; overflow-y: scroll;">
                        <div class="input-group flex-nowrap rounded hovering" :class="{'disabled-div': saving || gettingDevices}" v-for="(dev, dix) in filtered" v-bind:key="dix+1">
                            <button class="btn btn-deg-alchemy text-white" style="width: 7%;">
                                {{dix+1}}
                            </button>
                            <button v-if="false" class="btn fs-5" :class="{'btn-success': dev.include, 'btn-dark': !dev.include}" @click="dev.include = !dev.include" style="width: 3%;">
                                <i class="fa-solid" :class="{'fa-check': dev.include, 'fa-minus': !dev.include}"></i>
                            </button>
                            <button class="btn bg-gradient text-white" :class="{'btn-success': dev.active}" style="width: 5%;" @click="dev.active = !dev.active" title="Turn ON/OFF the monitoring of the device.">
                                {{dev.active ? 'ON':'OFF'}}
                            </button>
                            <input class="btn btn-deg-alchemy text-start fs-6" type="text" :value="dev.name" style=" width: 20%;" title="Device Name" readonly>
                            <input class="btn btn-deg-alchemy fs-6" type="text" :value="dev.alias" style=" width:20%;" title="Device Alias" readonly>
                            <input class="btn btn-deg-alchemy fs-6" type="text" :value="dev.ip" style=" width: 20%;" title="Device IP Address" readonly>
                            <button class="btn fs-6" :class="{'btn-info': dev.os == 'superficial', 'btn-deg-alchemy': dev.os != 'superficial'}" style="width: 5%; cursor: default;" :title="`Device OS: ${String(dev.os).toUpperCase()}`">
                                <i class="fa-solid mt-1" :class="{'fa-water': dev.os == 'superficial', 'fa-desktop': dev.os != 'superficial'}"></i>
                            </button>
                            <input type="number" class="btn btn-deg-alchemy fs-6" style="width: 6%; cursor: text;" v-model.number="dev.ping_tolerance" :title="`PING tolerance: ${dev.ping_tolerance}%\nRange: 1% - 100%\nSuccess Rate last value: ${dev.ping_success}%`">
                            <input type="number" class="btn btn-deg-alchemy fs-6" style="width: 9%; cursor: text;" v-model.number="dev.ping_latency_tolerance" :title="`LATENCY tolerance: ${dev.ping_latency_tolerance} ms\nRange: 1 ms - 20,000 ms\nLatency last value: ${dev.ping_latency} ms`">
                            <input type="number" class="btn btn-deg-alchemy fs-6" style="width: 9%; cursor: text;" v-model.number="dev.ping_jitter_tolerance" :title="`JITTER tolerance: ${dev.ping_jitter_tolerance} ms\nRange: 1 ms - 20,000 ms\nJitter last value: ${dev.ping_latency} ms`">
                            <!-- Ping Alarm Limit -->
                            <input v-if="dev.os != 'superficial'" type="number" class="btn btn-deg-alchemy fs-6" style="width: 6%; cursor: text;" :value="dev.ping_alarm_limit" :title="`PING ALARM limit: ${dev.ping_alarm_limit} atts\nRange: 1 attempts - 10 attempts\nAlarm counter last value: ${dev.ping_alarm_counter} atts`" readonly>
                            <input v-if="dev.os == 'superficial'" type="number" class="btn btn-deg-alchemy fs-6" style="width: 6%; cursor: text;" v-model.number="dev.ping_alarm_limit" :title="`PING ALARM limit: ${dev.ping_alarm_limit} atts\nRange: 1 attempts - 10 attempts\nAlarm counter last value: ${dev.ping_alarm_counter} atts`">
                            <!-- CPU & Memory -->
                            <input v-if="dev.os != 'superficial'" type="number" class="btn btn-deg-alchemy fs-6" style="width: 6%; cursor: text;" v-model.number="dev.cpu_tolerance" :title="`CPU tolerance: ${dev.cpu_tolerance}%\nRange: 1% - 100%\nCPU usage last value: ${dev.cpu_usage}%`">
                            <input v-if="dev.os != 'superficial'" type="number" class="btn btn-deg-alchemy fs-6" style="width: 6%; cursor: text;" v-model.number="dev.memory_tolerance" :title="`MEMORY tolerance: ${dev.memory_tolerance}%\nRange: 1% - 100%\nMemory usage last value: ${dev.memory_usage}%`">
                            <input v-if="dev.os == 'superficial'" type="text" class="btn btn-deg-alchemy text-center fs-6" style="width: 6%; cursor: text;" :value="'*'" title="CPU analysis is not available for superficial devices." readonly>
                            <input v-if="dev.os == 'superficial'" type="text" class="btn btn-deg-alchemy text-center fs-6" style="width: 6%; cursor: text;" :value="'*'" title="Memory analysis is not available for superficial devices." readonly>
                        </div>
                    </div>
                </div>

                <div class="col-md-12 mt-3 mb-3">
                    <div class="input-group flex-nowrap" :class="{'disabled-div': saving || gettingDevices}">
                        <label for="thfield" class="fs-3 text-white" style="width: 25%; letter-spacing: 5px; cursor: default;">Massive</label>
                        <select class="btn btn-success bg-gradient rounded fs-5" style="width: 30%;" id="thfield" v-model="sth" @change="setDefault();">
                            <option :value="null">Select a field to modify...</option>
                            <option value="active">Monitoring permission</option>
                            <option value="ping_tolerance">Ping Tolerance</option>
                            <option value="ping_latency_tolerance">Ping Latency Tolerance</option>
                            <option value="ping_jitter_tolerance">Ping Jitter Tolerance</option>
                            <option value="ping_alarm_limit">Ping Alarm Limit (ONLY superficial devices)</option>
                            <option value="cpu_tolerance">CPU Tolerance (Only NOT superficial devices.)</option>
                            <option value="memory_tolerance">Memory Tolerance (Only NOT superficial devices.)</option>
                        </select>
                        <div v-if="sth == null" class="btn text-white fs-5 w-25" disabled>
                            -
                        </div>
                        <button class="btn text-white border-0 border-top border-bottom border-success fs-5 w-25" :class="{'btn-success':cats[sth].val}" v-if="cats[sth].type == 'bool'" @click="cats[sth].val = !cats[sth].val">
                            {{cats[sth].val ? 'ON':'OFF'}}
                        </button>
                        <input class="btn text-white fs-5 border-0 border-top border-bottom border-success fs-5" style="cursor: text; width: 25%;" v-if="cats[sth].type == 'num'" v-model.number="cats[sth].val" type="number" :placeholder="`Range (${cats[sth].units}): ${cats[sth].low_lim} - ${cats[sth].high_lim}`">
                        <input class="btn text-white fs-5 border-0 border-top border-bottom border-success" v-if="cats[sth].type == 'num'" type="text" :value="cats[sth].units" style="width:5%;">
                        <button v-if="sth != null" class="btn btn-success rounded fs-4 ms-1" style="width: 5%;" @click="SetMassive()">
                            <i class="fa-solid fa-circle-arrow-up"></i>
                        </button>
                    </div>
                </div>


                
            </div>



        </div>
    </div>

</template>

<script>

import axios from "axios";

export default {
  name: 'Thresholds',
  components: {},
  data(){
    return {
        // General for the requests.
        site: null,
        stage: null,

        // Thresholds
        sth: null, // Selected thresholds.
        thresholds: {
            active : false
        },
        // Categories
        cats: {
            null: {type: null},
            active : { type: 'bool', val: false, rec: false },
            ping_tolerance: { type: 'num', val: 80, rec: 80, low_lim: 1, high_lim: 100, units:'%' },
            ping_latency_tolerance: { type: 'num', val: 20, rec: 20, low_lim: 1, high_lim: 20000, units:'ms' },
            ping_jitter_tolerance: { type: 'num', val: 10, rec: 10, low_lim: 1, high_lim: 20000, units:'ms' },
            ping_alarm_limit: { type: 'num', val: 2, rec: 2, low_lim: 1, high_lim: 10, units:'atts' },
            cpu_tolerance: { type: 'num', val: 80, rec: 60, low_lim: 1, high_lim: 100, units:'%' },
            memory_tolerance: { type: 'num', val: 80, rec: 60, low_lim: 1, high_lim: 100, units:'%' }
        },
        dfcats : {},
        // Devices
        gettingDevices: false,
        devices: [],
        keyword: null,
        // Saving
        saving: false

    }
  },
  // Methods
  methods:{
    getDevices(){
        this.gettingDevices = true
        const params = {filter: 'all'}
        const dest = this.site + '/alchemy/thresholds/getDevices'
        axios
            .get(dest, {params})
            .then(rx => {
                // OK
                this.devices = rx.data.data.devices
                this.gettingDevices = false
            })
            .catch(error => {
                this.gettingDevices = false
        });
    },
    SaveChanges(MODE){
        const devices = this.PreProcess()
        const params = {
            mode: MODE,
            data: devices
        }
        this.saving = true
        const dest = this.site + '/alchemy/thresholds/save'
        axios
            .post(dest, {params})
            .then(rx => {
                // OK
                alert('Changes saved.')
                this.getDevices()
                this.saving = false
            })
            .catch(error => {
                alert(error.response.data.data.errorMessage)
                this.saving = false
        });
    },
    SetMassive(field){
        var cat = this.cats[this.sth]
        if (cat.val === null || cat.val === ''){
            alert('Empty value.')
            return
        }
        console.log(cat)
        // Validate
        if (cat.type == 'bool'){
            //Code
        }
        else if (cat.type == 'num'){
            if (cat.val < cat.low_lim){
                alert(`Value under the limit: ${cat.val}`)
            }
            if (cat.val > cat.high_lim){
                alert(`Value above the limit: ${cat.val}`)
            }
        }
        // Set the value for all filtered devices
        for (let i = 0; i < this.filtered.length; i++) {
            const is_sup = this.filtered[i].os == 'superficial'

            // Ping Alarm Limit only for superficials.
            if (this.sth == 'ping_alarm_limit'){
                if (is_sup){
                    this.filtered[i][this.sth] = cat.val
                }
                else{
                    this.filtered[i][this.sth] = 1
                }
            }
            // Ping Alarm Limit only for superficials.
            else if (['cpu_tolerance','memory_tolerance'].includes(this.sth)){
                if (is_sup){
                    this.filtered[i][this.sth] = null
                }
                else{
                    this.filtered[i][this.sth] = cat.val
                }
            }
            else{
                this.filtered[i][this.sth] = cat.val
            }
            
        }
    },
    PreProcess(){
        var data = []
        for (let i = 0; i < this.filtered.length; i++) {
            const d = this.filtered[i];
            const devdict = {
                uid: d.uid,
                ip:  d.ip,
                name: d.name,
                alias: d.alias,
                os:  d.os,
                active: Boolean(d.active),
                ping_tolerance: d.ping_tolerance,
                ping_latency_tolerance: d.ping_latency_tolerance,
                ping_jitter_tolerance: d.ping_jitter_tolerance,
                ping_alarm_limit: d.ping_alarm_limit,
                cpu_tolerance: d.cpu_tolerance,
                memory_tolerance: d.memory_tolerance
            }
            data.push(devdict)
        }
        return data
    },
    print(){
        console.log('===================')
        for (let index = 0; index < this.filtered.length; index++) {
            const element = this.filtered[index];
            console.log('DEVICE:', element.name, element.ip, element.active)
        }
    },
    setDefault(){
        this.cats = this.cloneObject(this.dfcats)
    },
    cloneObject(_object){
      return JSON.parse(JSON.stringify(_object))
    },
    getCookie(name){
      const cookies = document.cookie.split(';');
      for (let cookie of cookies) {
            cookie = cookie.trim();
            if (cookie.startsWith(name + '=')) {
              return cookie.substring(name.length + 1);
            }
      }
      return null;
    }
  },
  computed:{
    filtered(){
        if (this.keyword == null || this.keyword == ""){
            return this.devices
        }
        this.keyword = this.keyword.toLowerCase()
        return this.devices.filter( d => d.ip.toLowerCase().includes(this.keyword) ||
                                         d.name.toLowerCase().includes(this.keyword) ||
                                         d.alias.toLowerCase().includes(this.keyword) ||
                                         d.os.toLowerCase().includes(this.keyword));
    }
  },
  created: function(){
    this.stage = process.env.NODE_ENV
    if (this.stage == 'development'){
      this.site = process.env.VUE_APP_SERVICE_URL
    }
    else{
      this.site = `${window.location.protocol}//${window.location.host}/kraken`
    }
    // Setting
    axios.defaults.headers.common['X-CSRFToken'] = this.getCookie('csrf_prt')
  },
  mounted: function(){
    this.dfcats = this.cloneObject(this.cats)
    this.getDevices()
  }
}

</script>

<style scoped>

    .bg-deg-alchemy{
        background-color: rgb(0, 0, 0);
        color: Black;
        box-shadow: 0px 0px 80px 0px rgb(9, 57, 108);
    }

    .btn-deg-alchemy{
        background-color: rgb(0, 0, 26);
        color: White;
        border: solid black 0px;
        box-shadow: 0px 0px 20px 0px rgb(9, 57, 108);
    }

    .hovering{
        border: solid 2px transparent;
    }
    .hovering:hover{
        border: solid 2px rgb(38, 167, 2);
    }

    .disabled-div{
        pointer-events: none;
        opacity: 0.5;
    }

</style>